<template>
	<div class="import-dialog">
		<el-dialog title="导入达人信息" :visible.sync="dialogVisible" width="530px" :before-close="handleClose">
			<div class="content">
				<div class="label">1、下载导入模版</div>
				<div class="handler download">
					<i class="el-icon-download"></i>
					<a :href="link" class="ml-4">下载模版</a>
				</div>
				<div class="label mt-24">2、选择要导入的Excel文件</div>
				<el-form class="mt-16 ml-20" :model="form" :rules="rules" ref="ruleForm">
					<el-form-item prop="file">
						<el-upload
							ref="upload"
							accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
							action="no"
							:auto-upload="false"
							:http-request="upload"
							:on-remove="fileChange"
							:on-change="fileChange"
						>
							<el-button slot="trigger">{{ btnText }}</el-button>
						</el-upload>
					</el-form-item>
				</el-form>
				<div class="attention" v-if="$isPlatOr(['Dy', 'Sp'])">
					<div>注意事项：</div>
					<div class="mt-12">1.请勿擅自修改导入模版的表头字段，否则会导致导入失败；</div>
					<div class="mt-12">2.联系人微信/手机号已填，联系人名称未填则系统默认赋为主播昵称；</div>
					<div class="mt-12">
						3.管理员导达人时系统根据模版内所填[商务手机号]进行自动分配，若该字段未填则达人导入后无跟进人，其余商务可在团队公海认领；商务自己导达人无需填写[商务手机号]所导达人均会认领到自己名下；
					</div>
				</div>
				<div class="attention" v-if="$isKs()">
					<div>注意事项：</div>
					<div class="mt-12">1.请勿擅自修改导入模版的表头字段，否则会导致导入失败；</div>
					<div class="mt-12">2.粉丝量、月销售额、场均销售额、主推类目为非必填字段，若系统已自动获取到达人数据则将覆盖您所填信息；</div>
					<div class="mt-12">3.联系人微信/手机号已填，联系人名称未填则系统默认赋为主播昵称；</div>
					<div class="mt-12">
						4.管理员导达人时系统根据模版内所填[商务手机号]进行自动分配，若该字段未填则达人导入后无跟进人，其余商务可在团队公海认领；商务自己导达人无需填写[商务手机号]所导达人均会认领到自己名下；
					</div>
				</div>
			</div>
			<span slot="footer">
				<el-button type="primary" @click="submit">开始导入</el-button>
			</span>
		</el-dialog>
		<!-- <import-result-dialog ref="importResultDialog" @showImportDialog="show" /> -->
		<hint-dialog ref="hintDialog" :sourcePage="sourcePage" />
	</div>
</template>

<script>
// import importResultDialog from './components/importResultDialog'
import hintDialog from './components/hintDialog';
import { batchAddTalent, partnerAnchorImportUrl, teamAnchorImportUrl } from '@/api/talentCRM';

export default {
	name: 'importDialog',
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
		sourcePage: {
			type: String,
			default: '',
		},
	},
	components: {
		// importResultDialog,
		hintDialog,
	},
	data() {
		return {
			dialogVisible: false,
			form: {
				file: [],
			},
			rules: {
				file: { required: true, message: '请选择要导入的Excel文件', trigger: 'change' },
			},
			link: '',
		};
	},
	computed: {
		btnText() {
			return this.form.file.length ? '重新添加' : '添加文件';
		},
	},
	methods: {
		show() {
			this.getImportUrl();
			this.dialogVisible = true;
		},
		async getImportUrl() {
			const api = {
				groupSeas: teamAnchorImportUrl,
				myTalent: partnerAnchorImportUrl,
				emphasisTalent: partnerAnchorImportUrl,
			};

			const { dy = '', ks = '', sph = '' } = await api[this.sourcePage]();
			const url = {
				[dataMap.PLATFORM_DY.value]: dy,
				[dataMap.PLATFORM_KS.value]: ks,
				[dataMap.PLATFORM_SP.value]: sph,
			};
			this.link = url[this.platformId];
		},
		handleClose(value) {
			this.form = {
				file: [],
			};
			this.link = '';
			this.$refs.ruleForm.resetFields();
			this.$refs.upload.clearFiles();
			if (!value) return;
			this.dialogVisible = false;
		},
		fileChange(_, fileList) {
			if (fileList.length > 1) fileList.shift();
			this.form.file = fileList;
			this.$refs.ruleForm.validateField('file');
		},
		async upload(val) {
			const formData = new FormData();
			formData.append('file', val.file);
			formData.append('platform_id', this.platformId);
			const is_sea = this.sourcePage == 'groupSeas' ? 1 : 0;
			formData.append('is_sea', is_sea);
			formData.append('new_version', 1);
			const { code } = await batchAddTalent(formData);
			if (code === 0) {
				this.$refs.upload.clearFiles();
				this.$refs.hintDialog.show();
				this.$emit('getList');
				this.handleClose(1);
			} else {
				this.handleClose();
			}
		},
		submit() {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				this.$refs.upload.submit();
			});
		},
	},
};
</script>

<style lang="less" scoped>
.content {
	padding: 0 4px;
	.label {
		font-size: 16px;
		color: #1d1f23;
	}
	.handler {
		margin-top: 16px;
		margin-left: 20px;
		&.download {
			font-size: 14px;
			color: #0053db;
			cursor: pointer;
		}
	}
	.attention {
		margin-top: 32px;
		font-size: 14px;
		color: #666;
	}
}
</style>
